import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { MyEInvoiceGenDocToIRBSubmissionHistoryContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_gen_doc_to_irb_submission_history_container.model';


@Injectable({
  providedIn: 'root'
})

export class MyEInvoiceGenDocToIRBSubmissionHistoryService extends BaseApiTemplateService<MyEInvoiceGenDocToIRBSubmissionHistoryContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/gendoc-to-irb-submission-histories/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/gendoc-to-irb-submission-histories/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/gendoc-to-irb-submission-histories/backoffice-ep'
    this.httpClient = http;
  }

}
